<div class="d-flex justify-content-between align-items-center gap-2 flex-wrap bg-dark small text-light px-2 py-1">
  <div class="d-flex flex-wrap gap-2">
    <app-is-online-status></app-is-online-status>

    <app-pdo-mode-status></app-pdo-mode-status>

    <span class="cursor-default">
      <app-release-version></app-release-version>
    </span>

    @if (modeEnabled$ | async) {
      <span class="px-1 fw-bold bg-info text-dark rounded cursor-default"> {{ modeText$ | async }} MODE </span>
    }
  </div>

  <ng-container *appIsElectron>
    <app-electron-zoom></app-electron-zoom>
  </ng-container>
</div>
